export default {"src":"/_next/static/media/close-banner.5b129c5b.svg","height":16,"width":16};